/** @format */

const theme = {
  id: "dark",
  primaryColor: "#edf2f8",
  secondaryColor: "#313bac",
  blackColor: "#030303",
  lightGrayColor: "#e4e4e4",
  grayColor: "#6b7688",
  brownColor: "#46364a",
  whiteColor: "#ffffff",

  //
  navBgColor: "#404040",
  sideBgColor: "#404040",
  linkColor: "#e4e4e4",
  linkHoverColor: "#ffffff",
  aboutCirclesColor: "#e4e4e4",
  app__whitebg: "#6b7688",
  app__primarybg: "#030303",
  app__headtext: "#red",
  app__headtextspan: "red",
  app__textp: "#030303",
  app__headerbadge: "#6b7688",
};

export default theme;
